import { Outlet, createFileRoute } from "@tanstack/react-router";

import { organizationsLayoutCrumb } from "@/lib/crumb-resolvers";

// 注: ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/organizations")({
  staticData: { crumb: organizationsLayoutCrumb() },
  component: () => <Outlet />,
});
